import { render, staticRenderFns } from "./TaskListLayout.vue?vue&type=template&id=41aaccf5&"
import script from "./TaskListLayout.vue?vue&type=script&lang=ts&"
export * from "./TaskListLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports